import { pageIntroContent } from '@insify/css/classes.module.css';
import { Button } from '@insify/design-system/components';

import { RichContentWithTooltip } from '../../../../components/RichContent';
import { useSearch } from '../../useSearchPage';

import { footer as classNameFooter, submitButton } from './SearchPageContainer.module.css';

import type { SearchCopy } from '../../SearchPage';
import type React from 'react';

export const SearchPageContainer: React.FC<Omit<SearchCopy, 'noResult' | 'id'> & { children: React.ReactNode }> = ({
  children,
  footer,
  richContent,
  translations,
}) => {
  const { selected, goToNextPage, searchString, isSubmitting, continueWithoutSelection } = useSearch();
  return (
    <>
      {richContent !== undefined ? <RichContentWithTooltip {...richContent} className={pageIntroContent} /> : null}
      {children}
      {!searchString && translations.continueWithoutValue && (
        <Button
          data-testid='continue-without-result'
          type='button'
          kind='secondary'
          trackingId='continue-without-result'
          loading={isSubmitting}
          onClick={continueWithoutSelection}
        >
          {translations.continueWithoutValue}
        </Button>
      )}
      {!!selected && !searchString && translations.forward && (
        <Button
          type='button'
          kind='primary'
          trackingId='continue'
          loading={isSubmitting}
          onClick={goToNextPage}
          className={submitButton}
        >
          {translations.forward}
        </Button>
      )}
      {footer && <div className={classNameFooter}>{footer}</div>}
    </>
  );
};
